import React from 'react';
import { useNavigate } from 'react-router-dom';

const HeroSection: React.FC = () => {
  const navigate = useNavigate();
  
  const scrollToNext = () => {
    const nextSection = document.getElementById('vision');
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleContactClick = () => {
    navigate('/contact');
  };

  return (
    <section id="hero" className="relative h-[70vh] sm:h-[75vh] md:h-[80vh] lg:h-[60vh] xl:h-[55vh] w-full overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="/photos/main.jpg"
          alt="Kauai bridal styling moment"
          className="w-full h-full object-cover object-center transform scale-110"
        />
        <div className="absolute inset-0 bg-black bg-opacity-30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col justify-center items-center h-full text-center text-white px-4 sm:px-6">
        <div className="max-w-4xl animate-fade-in-up mb-12 sm:mb-16 md:mb-20">
          <h1 className="font-serif text-3xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl mb-3 sm:mb-4 md:mb-6 leading-tight">
            Your Most Beautiful Day
            <span className="block text-sunset-coral">Begins Here</span>
          </h1>
          
          <p className="text-sm sm:text-sm md:text-base lg:text-lg xl:text-xl mb-4 sm:mb-6 md:mb-8 font-light leading-relaxed max-w-2xl mx-auto">
            Kauai's premier bridal hair & makeup artist creating stunning, 
            humidity-proof looks that capture your radiance and last from 
            "I do" to your last dance
          </p>

          <button
            onClick={handleContactClick}
            className="inline-block bg-sunset-coral hover:bg-opacity-90 text-white font-semibold py-2 px-4 sm:py-3 sm:px-6 md:py-4 md:px-8 rounded-full text-xs sm:text-sm md:text-base lg:text-lg transition-all duration-300 transform hover:scale-105 shadow-lg md:hidden"
          >
            Contact Us
          </button>
          <button
            onClick={handleContactClick}
            className="hidden md:inline-block bg-sunset-coral hover:bg-opacity-90 text-white font-semibold py-2 px-4 sm:py-3 sm:px-6 md:py-4 md:px-8 rounded-full text-xs sm:text-sm md:text-base lg:text-lg transition-all duration-300 transform hover:scale-105 shadow-lg"
          >
            Contact Us
          </button>
        </div>

        {/* Scroll Indicator - Variation 1 */}
        <div className="absolute bottom-4 sm:bottom-6 md:bottom-8 left-0 right-0 animate-bounce">
          <div className="flex flex-col items-center justify-center w-full">
            <button
              onClick={scrollToNext}
              className="text-white hover:text-sunset-coral transition-colors duration-300 mb-1"
            >
              <svg className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
              </svg>
            </button>
            <p className="text-xs font-light">Scroll to discover your journey</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
